export const AuthRoute = {
    SIGN_IN: '/account-login/'
}